import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Leaf, ArrowRight, Sparkles } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const HerbOfWeek = () => {
  const [herb, setHerb] = useState(null);

  useEffect(() => {
    axios.get(`${API}/herbs/featured/week`).then(({ data }) => setHerb(data)).catch((e) => console.debug("Herb of week unavailable:", e?.message));
  }, []);

  if (!herb) return null;

  return (
    <section className="py-16 bg-white" data-testid="herb-of-week-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative rounded-3xl overflow-hidden bg-[#0F3D2E] shadow-2xl">
          <div className="grid md:grid-cols-2 items-stretch">
            <div className="relative min-h-[260px]">
              {herb.image_url && (
                <img src={herb.image_url} alt={herb.name} loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
              )}
              <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#0F3D2E]/60 hidden md:block"></div>
              <div className="absolute inset-0 bg-gradient-to-t from-[#0F3D2E]/70 to-transparent md:hidden"></div>
            </div>
            <div className="p-8 md:p-10 flex flex-col justify-center">
              <span className="inline-flex items-center gap-2 self-start bg-amber-400/20 text-amber-200 border border-amber-300/30 rounded-full px-4 py-1.5 text-xs font-bold tracking-widest uppercase mb-4">
                <Sparkles className="w-3.5 h-3.5" /> Herb of the Week
              </span>
              <h2 className="font-playfair text-3xl md:text-4xl font-bold text-white mb-1">{herb.name}</h2>
              {herb.scientific_name && (
                <p className="text-emerald-200/70 italic text-sm mb-4">{herb.scientific_name}</p>
              )}
              <p className="text-emerald-50/90 text-sm md:text-base leading-relaxed mb-5 line-clamp-3">{herb.description}</p>
              {Array.isArray(herb.benefits) && herb.benefits.length > 0 && (
                <div className="flex flex-wrap gap-2 mb-6">
                  {herb.benefits.slice(0, 3).map((b) => (
                    <span key={b} className="bg-white/10 text-emerald-100 rounded-full px-3 py-1 text-xs flex items-center gap-1.5">
                      <Leaf className="w-3 h-3" /> {b}
                    </span>
                  ))}
                </div>
              )}
              <div className="flex flex-wrap gap-3">
                <Link
                  to={`/herbs/${herb.id}`}
                  className="inline-flex items-center gap-2 bg-white text-primary px-6 py-3 rounded-full text-sm font-bold hover:bg-emerald-50 transition-colors"
                  data-testid="herb-of-week-learn-btn"
                >
                  Learn More <ArrowRight className="w-4 h-4" />
                </Link>
                <Link
                  to="/store"
                  className="inline-flex items-center gap-2 border border-white/40 text-white px-6 py-3 rounded-full text-sm font-bold hover:bg-white/10 transition-colors"
                  data-testid="herb-of-week-shop-btn"
                >
                  Shop It
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
